// ─── Voxist Design Tokens ────────────────────────────────────────
// Single source of truth for all design primitives.
// Import this file wherever raw token values are needed outside the MUI theme.

export const tokens = {
  colors: {
    primary: {
      main: '#00cff3',
      light: '#5ce1f8',
      dark: '#009dbf',
      /** WCAG AA 4.5:1+ on white — use for text/icons on light backgrounds */
      darkText: '#007d8a',
      50: '#e0f7fc',
      100: '#b3ecf9',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#33ebcb',
      light: '#7af1dc',
      dark: '#00b89a',
      /** WCAG AA 4.5:1+ on white — use for text/icons on light backgrounds */
      darkText: '#00856e',
      contrastText: '#003028',
    },
    tts: {
      main: '#004a57',
      light: '#00758a',
      surface: '#e0f2f4',
      surfaceDark: '#0a2a30',
    },
    success: {
      main: '#10b981',
      light: '#d1fae5',
      dark: '#059669',
    },
    warning: {
      main: '#f59e0b',
      light: '#fef3c7',
      dark: '#b45309',
    },
    error: {
      main: '#ef4444',
      light: '#fee2e2',
      dark: '#dc2626',
    },
    neutral: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      /** WCAG AA on white (~4.6:1) — minimum for secondary text */
      600: '#64748b',
      700: '#475569',
      800: '#1e1e1e',
      850: '#1a1a1a',
      900: '#121212',
      950: '#0a0a0a',
    },
  },
  gradients: {
    primary: 'linear-gradient(135deg, #00cff3 0%, #33ebcb 100%)',
    primaryHover: 'linear-gradient(135deg, #009dbf 0%, #00b89a 100%)',
    horizontal: 'linear-gradient(to right, #00cff3, #33ebcb)',
    alt: 'linear-gradient(145deg, #00cff3, #4eedd2)',
    dark: 'linear-gradient(135deg, #004a57 0%, #006b6b 100%)',
    tts: 'linear-gradient(135deg, #004a57 0%, #00758a 100%)',
  },
  radius: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    pill: 40,
    full: '50%',
  },
  typography: {
    fontFamily: '"Lato", "Helvetica Neue", Arial, sans-serif',
    fontFamilyMono: '"JetBrains Mono", "Fira Code", "Cascadia Code", Consolas, monospace',
  },
};
